<template>
  <div class="login-wrap" v-show="showLogin">
    <div class="login-cont">
      <iframe :src="iframeSrc" frameborder="0" scrolling="no"></iframe>
      <Icon type="md-close" class="close-btn" @click="hideLogin"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    returnUrl: String,
  },
  computed: mapState({
    iframeSrc: state => state.login.iframeSrc,
    showLogin: state => state.login.showLogin,
  }),
  created() {
    this.$store.commit('setReturnUrl', this.returnUrl);
    this.$store.dispatch('getUserInfo');
  },
  methods: {
    hideLogin() {
      this.$store.commit('setShowLogin', false);
    },
  },
};
</script>

<style>
.login-wrap{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-cont{
  position: relative;
  width: 320px;
  max-width: 90%;
}
.login-wrap iframe{
  background-color: #fff;
  width: 100%;
  height: 300px;
}
.close-btn{
  color: #999;
  font-size: 20px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue